import LS from 'utils/bom-dom-manipulation/local-storage';
import { storageKeyName } from 'utils/generic/storage-key-name';
import { InitialUserData } from 'interfaces/authentication';
import store from 'store';

export const checkIsUserLoggedIn = () => {
  const userData: InitialUserData = store.getState().userData;
  const authData = JSON.parse(
    LS.getItem(storageKeyName('account', 'AUTH_DATA'))
  );

  if (authData?.auth_token) {
    return true;
  }

  return userData.isLoggedIn;
};
